import * as React from 'react';
/**
 * @internal
 */ const defaultContextValue = 'unmounted';
// Contexts should default to undefined
/**
 * @internal
 */ export const DialogTransitionContext = React.createContext(undefined);
/**
 * @internal
 */ export const DialogTransitionProvider = DialogTransitionContext.Provider;
/**
 * @internal
 */ export const useDialogTransitionContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(DialogTransitionContext)) !== null && _React_useContext !== void 0 ? _React_useContext : defaultContextValue;
};
